const updateInitialState = {
  code: null,
  updating: false,
};

const update = (state = updateInitialState, action) => {
  switch (action.type) {
    case 'UPDATE_MAPPING_CODE':
      return {
        ...state,
        code: action.code,
      };

    case 'CANCEL_UPDATE_MAPPING_CODE':
      return updateInitialState;

    case 'CHANGE_MAPPING_CODE':
      return {
        ...state,
        code: action.code,
      };

    case 'UPDATE_MAPPING':
      return {
        ...state,
        updating: true,
      };

    case 'UPDATE_MAPPING_SUCCESS':
      return updateInitialState;

    case 'UPDATE_MAPPING_FAILURE':
      return {
        ...state,
        updating: false,
      };

    default:
      return state;
  }
};

export default update;

export const isUpdating = (state) => state.updating;

export const getCode = (state) => state.code;
